import { authHeader, handleResponse } from '../utils'
import { API_BASE } from '../config/constants'

// const sendStartAllRequest = async() => {
//     const requestOptions = {
//         method: 'POST',
//         headers: { ...authHeader(), 'Content-Type': 'application/json' }
//     }
//     const response = fetch(`${API_BASE}/ai/startSearchAllArtworks`, requestOptions)
//     return await handleResponse(response);
// }

// const sendCancelAllRequest = async() => {
//     const requestOptions = {
//         method: 'POST',
//         headers: { ...authHeader(), 'Content-Type': 'application/json' }
//     }

//     const response = fetch(`${API_BASE}/ai/cancelSearchAllArtworks`, requestOptions)
//     return await handleResponse(response);
// }

const sendStartRandomRequest = async () => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    }
    const response = fetch(`${API_BASE}/ai/startSearchRandomArtworks`, requestOptions)
    return await handleResponse(response);
}

const sendCancelRandomRequest = async () => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    }
    const response =  fetch(`${API_BASE}/ai/cancelSearchRandomArtworks`, requestOptions)
    return await handleResponse(response);
}

const getDelUrls = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    }
    const response = fetch(`${API_BASE}/ai/getDelUrls`, requestOptions)
    return await handleResponse(response);
}

const getDelTermUrls = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    }
    const response = fetch(`${API_BASE}/ai/getDelTermUrls`, requestOptions);
    return await handleResponse(response);
}

const getWarnInfos = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    };

    const response = fetch(`${API_BASE}/ai/getWarnInfos`, requestOptions);
    return await handleResponse(response);
}

const getDashboardStats = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
    };
    const response = fetch(`${API_BASE}/ai/getDashboardStats`, requestOptions);
    return await handleResponse(response);
};

const getScanLogs = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
    };
    const response = fetch(`${API_BASE}/ai/getScanLogs`, requestOptions);
    return await handleResponse(response);
};

export const aiService = {
    getDelUrls,
    getDelTermUrls,
    sendStartRandomRequest,
    sendCancelRandomRequest,
    getWarnInfos,
    getDashboardStats,
    getScanLogs,
}